import {ReactNode} from "react";
import {css} from "@panda/css";

import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {Highlight, Text} from "@pg-design/text-module";
import {areaFormat, numberFormat} from "@pg-mono/string-utils";

import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {isPropertyDetail} from "../../../property/utils/is_property_detail";
import {getCurrency} from "../../../utils/get_currency";
import {
    getTinderMultiLeadAddress,
    getTinderMultiLeadImage,
    getTinderMultiLeadLocationName,
    getTinderMultiLeadOfferTypeName,
    TINDER_MULTI_LEAD_EMPTY_VALUE
} from "./tinder_multi_lead_utils";
import {TinderMultiLeadGallery} from "./TinderMultiLeadGallery";

interface IProps {
    parameterList: ReactNode;
    property: IPropertyDetail | IRecommendedProperty;
    shouldShowPrice: boolean;
    onGalleryClick: () => void;
    onMainImageClick: () => void;
    onPlanClick: () => void;
}

export function TinderMultiLeadHero({parameterList, property, shouldShowPrice, onGalleryClick, onMainImageClick, onPlanClick}: IProps) {
    const image = getTinderMultiLeadImage(property);
    const planImageUrl = isPropertyDetail(property) ? property.external_plan_url || property.plan_image_pages?.[0]?.image.p_img_760x428 || null : null;
    const currency = isPropertyDetail(property) ? getCurrency({currency: property.offer.currency}) : "zł";
    const priceNumber = shouldShowPrice && property.price ? numberFormat(property.price) : null;
    const priceM2Value =
        isPropertyDetail(property) && property.price_m2 ? property.price_m2 : property.price && property.area ? property.price / property.area : null;
    const priceM2Number = shouldShowPrice && priceM2Value ? numberFormat(Math.round(priceM2Value)) : null;
    const address = getTinderMultiLeadAddress(property);
    const location = getTinderMultiLeadLocationName(property);
    const offerTypeName = getTinderMultiLeadOfferTypeName(property.offer.type);

    return (
        <div className={heroStyle}>
            <TinderMultiLeadGallery
                imageUrl={image}
                offerName={property.offer.name}
                planImageUrl={planImageUrl}
                onGalleryClick={onGalleryClick}
                onMainImageClick={onMainImageClick}
                onPlanClick={onPlanClick}
            />

            <div className={infoColumnStyle}>
                <div className={priceHeaderStyle}>
                    <div className={priceRowStyle}>
                        {priceNumber ? (
                            <Text variant="headline_3" as="span" strong color="var(--colors-secondary)">
                                <Highlight>
                                    {priceNumber}{" "}
                                    <Text as="span" variant="body_copy_2" strong color="var(--colors-secondary)">
                                        {currency}
                                    </Text>
                                </Highlight>
                            </Text>
                        ) : (
                            <Text variant="body_copy_1" strong color="var(--colors-secondary)">
                                {TINDER_MULTI_LEAD_EMPTY_VALUE}
                            </Text>
                        )}

                        {priceM2Number && (
                            <span className={priceM2Style}>
                                <Text as="span" variant="info_txt_1" strong color="var(--colors-secondary)">
                                    {priceM2Number}
                                </Text>{" "}
                                <Text as="span" variant="info_txt_3" strong color="var(--colors-secondary)">
                                    {currency}/m²
                                </Text>
                            </span>
                        )}
                    </div>

                    <div className={addressRowStyle}>
                        <MapMarkerOutlineIcon size="1.6" wrapperSize="1.6" wrapperColor="transparent" fill="var(--colors-black)" />
                        <Text variant="info_txt_2" color="var(--colors-black)">
                            {address}
                        </Text>
                    </div>

                    <Text variant="body_copy_2" as="p" color="var(--colors-secondary)">
                        <strong>
                            {property.rooms}-pokojowe {offerTypeName}
                        </strong>{" "}
                        o powierzchni <strong>{areaFormat(property.area, {precision: 2})}</strong> <strong>{location}</strong>.
                    </Text>
                </div>

                {parameterList}
            </div>
        </div>
    );
}

const heroStyle = css({
    display: "grid",
    md: {
        gridTemplateColumns: "minmax(0, 1.9fr) minmax(0, 1fr)",
        alignItems: "stretch"
    }
});

const infoColumnStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 3,
    px: 1.5,
    py: 1.5,
    md: {
        px: 2,
        py: 2
    }
});

const priceHeaderStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});

const priceRowStyle = css({
    display: "flex",
    alignItems: "baseline",
    justifyContent: "flex-start",
    gap: 2
});

const priceM2Style = css({
    whiteSpace: "nowrap"
});

const addressRowStyle = css({
    display: "inline-flex",
    alignItems: "center",
    gap: 0.5
});
import {ReactNode} from "react";
import {css} from "@panda/css";

import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {Highlight, Text} from "@pg-design/text-module";
import {areaFormat, numberFormat} from "@pg-mono/string-utils";

import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {isPropertyDetail} from "../../../property/utils/is_property_detail";
import {getCurrency} from "../../../utils/get_currency";
import {
    getTinderMultiLeadAddress,
    getTinderMultiLeadImage,
    getTinderMultiLeadLocationName,
    getTinderMultiLeadOfferTypeName,
    TINDER_MULTI_LEAD_EMPTY_VALUE
} from "./tinder_multi_lead_utils";
import {TinderMultiLeadGallery} from "./TinderMultiLeadGallery";

interface IProps {
    parameterList: ReactNode;
    property: IPropertyDetail | IRecommendedProperty;
    shouldShowPrice: boolean;
    onGalleryClick: () => void;
    onMainImageClick: () => void;
    onPlanClick: () => void;
}

export function TinderMultiLeadHero({parameterList, property, shouldShowPrice, onGalleryClick, onMainImageClick, onPlanClick}: IProps) {
    const image = getTinderMultiLeadImage(property);
    const planImageUrl = isPropertyDetail(property) ? property.external_plan_url || property.plan_image_pages?.[0]?.image.p_img_760x428 || null : null;
    const currency = isPropertyDetail(property) ? getCurrency({currency: property.offer.currency}) : "zł";
    const priceNumber = shouldShowPrice && property.price ? numberFormat(property.price) : null;
    const priceM2Value =
        isPropertyDetail(property) && property.price_m2 ? property.price_m2 : property.price && property.area ? property.price / property.area : null;
    const priceM2Number = shouldShowPrice && priceM2Value ? numberFormat(Math.round(priceM2Value)) : null;
    const address = getTinderMultiLeadAddress(property);
    const location = getTinderMultiLeadLocationName(property);
    const offerTypeName = getTinderMultiLeadOfferTypeName(property.offer.type);

    return (
        <div className={heroStyle}>
            <TinderMultiLeadGallery
                imageUrl={image}
                offerName={property.offer.name}
                planImageUrl={planImageUrl}
                onGalleryClick={onGalleryClick}
                onMainImageClick={onMainImageClick}
                onPlanClick={onPlanClick}
            />

            <div className={infoColumnStyle}>
                <div className={priceHeaderStyle}>
                    <div className={priceRowStyle}>
                        {priceNumber ? (
                            <Text variant="headline_3" as="span" strong color="var(--colors-secondary)">
                                <Highlight>
                                    {priceNumber}{" "}
                                    <Text as="span" variant="body_copy_2" strong color="var(--colors-secondary)">
                                        {currency}
                                    </Text>
                                </Highlight>
                            </Text>
                        ) : (
                            <Text variant="body_copy_1" strong color="var(--colors-secondary)">
                                {TINDER_MULTI_LEAD_EMPTY_VALUE}
                            </Text>
                        )}

                        {priceM2Number && (
                            <span className={priceM2Style}>
                                <Text as="span" variant="info_txt_1" strong color="var(--colors-secondary)">
                                    {priceM2Number}
                                </Text>{" "}
                                <Text as="span" variant="info_txt_3" strong color="var(--colors-secondary)">
                                    {currency}/m²
                                </Text>
                            </span>
                        )}
                    </div>

                    <div className={addressRowStyle}>
                        <MapMarkerOutlineIcon size="1.6" wrapperSize="1.6" wrapperColor="transparent" fill="var(--colors-black)" />
                        <Text variant="info_txt_2" color="var(--colors-black)">
                            {address}
                        </Text>
                    </div>

                    <Text variant="body_copy_2" as="p" color="var(--colors-secondary)">
                        <strong>
                            {property.rooms}-pokojowe {offerTypeName}
                        </strong>{" "}
                        o powierzchni <strong>{areaFormat(property.area, {precision: 2})}</strong> <strong>{location}</strong>.
                    </Text>
                </div>

                {parameterList}
            </div>
        </div>
    );
}

const heroStyle = css({
    display: "grid",
    md: {
        gridTemplateColumns: "minmax(0, 1.9fr) minmax(0, 1fr)",
        alignItems: "stretch"
    }
});

const infoColumnStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 3,
    px: 1.5,
    py: 1.5,
    md: {
        px: 2,
        py: 2
    }
});

const priceHeaderStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});

const priceRowStyle = css({
    display: "flex",
    alignItems: "baseline",
    justifyContent: "flex-start",
    gap: 2
});

const priceM2Style = css({
    whiteSpace: "nowrap"
});

const addressRowStyle = css({
    display: "inline-flex",
    alignItems: "center",
    gap: 0.5
});
